module.exports = __webpack_public_path__ + "fonts/df3024c.eot";